import { Plus } from "lucide-react";
import type { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Link } from "react-router-dom";
import { DataTable } from "@/components/data-table/DataTable";
import { usePagedQuery } from "@/components/data-table/usePagedQuery";
import { FRANQUIA_PATH, type Franquia, type FranquiaFiltro } from "./api";

// Porte de app/controllers/consulta-franquia.controller.js +
// app/templates/franquia/consulta-franquia.html. Tela mais simples encontrada
// até agora: só consulta, sem modal e sem ações de linha — o legado nem tem
// edição, só "Adicionar Novo" levando a /Franquia/Adicionar.
const QUERY_KEY = ["franquia"];

const columns: ColumnDef<Franquia, unknown>[] = [
  { accessorKey: "razaoSocial", header: "Razão Social", enableSorting: true },
  { accessorKey: "nomeFantasia", header: "Nome Fantasia", enableSorting: true },
  { accessorKey: "email", header: "Email", enableSorting: true },
  { accessorKey: "cnpj", header: "CNPJ", enableSorting: true },
];

export default function ConsultaFranquia() {
  const query = usePagedQuery<Franquia, FranquiaFiltro>({
    key: QUERY_KEY,
    path: FRANQUIA_PATH,
    initialFiltro: {},
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold text-foreground">Franquias</h1>
        <Button asChild>
          <Link to="/Franquia/Adicionar">
            <Plus className="mr-2 h-4 w-4" /> Adicionar Novo
          </Link>
        </Button>
      </div>

      <DataTable
        query={query}
        columns={columns}
        getRowId={(r) => r.id}
        exportFilename="franquias"
        emptyMessage="Nenhuma franquia encontrada."
        toolbar={
          <div className="flex flex-wrap items-end gap-3">
            <div className="w-40">
              <Label htmlFor="f-codigo">Código</Label>
              <Input
                id="f-codigo"
                value={query.draft.codigo ?? ""}
                onChange={(e) => query.setDraft((f) => ({ ...f, codigo: e.target.value }))}
                onKeyDown={(e) => e.key === "Enter" && query.search()}
              />
            </div>
            <div className="w-64">
              <Label htmlFor="f-razao">Razão social / Nome fantasia</Label>
              <Input
                id="f-razao"
                value={query.draft.razaoSocial ?? ""}
                onChange={(e) => query.setDraft((f) => ({ ...f, razaoSocial: e.target.value }))}
                onKeyDown={(e) => e.key === "Enter" && query.search()}
              />
            </div>
            <div className="w-48">
              <Label htmlFor="f-cnpj">CNPJ</Label>
              <Input
                id="f-cnpj"
                value={query.draft.cnpj ?? ""}
                onChange={(e) => query.setDraft((f) => ({ ...f, cnpj: e.target.value }))}
                onKeyDown={(e) => e.key === "Enter" && query.search()}
              />
            </div>
            <Button onClick={query.search}>Buscar</Button>
          </div>
        }
      />
    </div>
  );
}
